import Image from "next/image"

export default function AnimatedLogo({ className = "" }: { className?: string }) {
  return (
    <div className={`relative flex flex-col justify-center logo-group ${className}`}>
      <Image 
        src="/hm-logo-transparent.png" 
        alt="HM Premium Logo" 
        width={36} 
        height={36} 
        priority
        className="w-auto h-9 drop-shadow-[0_0_12px_rgba(255,255,255,0.3)] transition-transform duration-500 hover:scale-105"
      />
      
      <style>{`
        .logo-group {
          animation: logo-reveal 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          opacity: 0;
          transform: translateY(4px);
        }
        @keyframes logo-reveal {
            to { opacity: 1; transform: translateY(0); }
        }
      `}</style>
    </div>
  )
}
